import useSWR from 'swr'

import { FeaturesResponse } from './types'
import { API } from '@/api/endpoints'

/**
 * GET All
 */
type UseFeaturesOptions = {
  hidden?: number
  scope?: 'property' | 'advertisement'
}

export const useFeatures = (options?: UseFeaturesOptions) => {
  const params = new URLSearchParams()

  if (options?.hidden !== undefined) {
    params.append('hidden', String(options.hidden))
  }

  if (options?.scope) {
    params.append('scope', options.scope)
  }

  const queryString = params.toString()
  const url = `${API.FEATURES}${queryString ? `?${queryString}` : ''}`

  const { data, error, isLoading, mutate } = useSWR<FeaturesResponse>(url)

  return {
    features: data,
    isLoading,
    error,
    mutate
  }
}
